<template >
  <div class="content">
    <div class="contact">
      <div class="title">
        <span></span>
        <h2>联系我们</h2>
        <!-- <span v-show="lang == '1'">Contact US</span> -->
      </div>
      <div class="text">
        <p>
          无论您以何种方式与我们联系，我们都将竭力为您提供优质的产品与服务。
        </p>
        <!-- <p v-show="lang == '1'">
          We respect our customers. You are welcome to call the 24-hour service
          hotline. You are also welcome to come in person!
        </p> -->
      </div>
      <div class="tabs_content" style="margin-top: 60px; margin-left: -200px">
        <div class="left_text">
          <p>{{ CompanyInfor[tabsIndex].cmpName }}</p>
          <div class="item">
            <svg
              t="1653458515640"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6930"
              width="28"
              height="28"
            >
              <path
                d="M932.6 878.3H889V311.1c0.1-6.3-3.5-12.1-9.1-15.1L629.7 165c-11.8-6.2-26.1 2.2-26.1 15.1v698.3H573V80.9c0.1-11.9-12.1-20.1-23.8-16L167.5 201.8c-6.9 2.4-11.5 8.9-11.5 16v660.5H92c-9.7 0-17.5 9.2-17.5 20.4v40.7c0 11.2 7.8 20.4 17.5 20.4h840.6c9.7 0 17.5-9.1 17.5-20.4v-40.7c0-11.2-7.8-20.4-17.5-20.4zM693.1 318.2c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.1c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.3c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 105.3c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7V647c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.1c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7V730zM394.4 217.5c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.7c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 105.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7V647c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7V730zM237.8 318.2c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 105.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7V647c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7V730z"
                p-id="6931"
                fill="#004aa1"
              ></path>
            </svg>
            <span>地址</span>
            <!-- <span v-show="lang == '1'">address</span> -->
            <p>{{ CompanyInfor[tabsIndex].cmpAddress }}</p>
          </div>
          <div class="item">
            <svg
              t="1653459034663"
              class="icon"
              viewBox="0 0 1025 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="10661"
              width="28"
              height="28"
            >
              <path
                d="M507.918859 650.527512c-49.503789-40.346806-106.623387-94.611243-156.090335-155.822216-34.713235-42.89496-65.404683-87.94306-33.707276-119.633303L95.656089 153.242337C63.221866 193.655661-8.620745 386.103763 299.338585 701.174388c324.458887 332.036833 533.74323 261.005742 569.766359 223.573453L652.205814 708.149578C621.886867 738.400983 582.842793 711.503113 507.918859 650.527512zM947.385483 798.906865l0-0.201601c0 0-169.23738-168.702166-169.343809-168.769707-13.381394-13.347623-34.814547-13.078481-48.127376 0.067541l-61.340939 61.375733 217.469138 217.203066c0 0 61.409504-61.176179 61.342986-61.245767l0.165784-0.132013C961.605005 833.148333 960.162074 811.75202 947.385483 798.906865zM396.298428 297.126091l0-0.168854c14.051691-14.083415 12.74589-35.45005 0-48.196964l0-0.234348c0 0-174.132089-173.597897-174.200654-173.597897-13.452005-13.484753-34.884135-13.148069-48.163193 0l-61.342986 61.441228 222.299375 221.961668C334.888924 358.335017 396.298428 297.225356 396.298428 297.126091z"
                p-id="10662"
                fill="#004aa1"
              ></path>
            </svg>
            <span>电话</span>
            <!-- <span v-show="lang == '1'">Telephone number</span> -->
            <!-- <p>{{ CompanyInfor[tabsIndex].cmpTelephone }}</p> -->
            <p style="margin-left: -10px">
              <span style="font-weight: 300; font-size: 15px; color: #2c3e50"
                >0546-8778677</span
              >
              |
              <span style="font-weight: 300; font-size: 15px; color: #2c3e50"
                >0546-7773879</span
              >
            </p>
          </div>
          <div class="item">
            <svg
              t="1653459120545"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="11703"
              width="28"
              height="28"
            >
              <path
                d="M1022.08 716.928V300.48l-217.28 217.344 217.28 199.04M655.36 667.2a188.16 188.16 0 0 1-133.888 55.488c-50.56 0-98.176-19.712-133.952-55.488L270.976 550.592 20.864 779.84v38.4c0 50.24 40.832 91.072 91.008 91.072h819.2c50.176 0 91.008-40.832 91.008-91.008v-39.68l-249.536-228.608-117.12 117.12"
                fill="#004aa1"
                p-id="11704"
              ></path>
              <path
                d="M932.928 128h-819.2C63.616 128 22.848 168.832 22.848 219.008v19.008l398.784 398.912c27.2 27.136 63.36 42.112 101.76 42.112 38.464 0 74.624-14.976 101.76-42.112L1024 238.016v-19.008C1024 168.832 983.04 128 932.928 128M20.864 300.48v417.6L238.72 518.4 20.864 300.48"
                fill="#004aa1"
                p-id="11705"
              ></path>
            </svg>
            <span>邮箱</span>
            <!-- <span v-show="lang == '1'">E-mail</span> -->
            <p>service@suree.cn</p>
          </div>
          <div class="item">
            <svg
              t="1653459369775"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="12743"
              width="28"
              height="28"
            >
              <path
                d="M727.54062222 86.74417778c19.22389333 0 34.95253333 15.72864 34.95253333 34.95253333v780.60657778c0 19.22389333-15.72864 34.95253333-34.95253333 34.95253333H296.45937778c-19.22389333 0-34.95253333-15.72864-34.95253333-34.95253333V121.69671111c0-19.22389333 15.72864-34.95253333 34.95253333-34.95253333h431.08124444m0-69.90506667H296.45937778c-57.67168 0-104.8576 47.18592-104.8576 104.8576v780.60657778c0 57.67168 47.18592 104.8576 104.8576 104.8576h431.08124444c57.67168 0 104.8576-47.18592 104.8576-104.8576V121.69671111c0-57.67168-47.18592-104.8576-104.8576-104.8576z"
                fill="#004aa1"
                p-id="12744"
              ></path>
              <path
                d="M765.40586667 789.87264H258.59413333c-36.70016 0-66.99235555 29.70965333-66.99235555 66.99235555v50.68117334c0 36.70016 29.70965333 66.99235555 66.99235555 66.99235556h506.81173334c36.70016 0 66.99235555-29.70965333 66.99235555-66.99235556v-50.68117334c0-37.28270222-30.29219555-66.99235555-66.99235555-66.99235555z m-254.57095112 136.89742222c-29.12711111 0-53.01134222-23.88423111-53.01134222-53.01134222s23.88423111-53.01134222 53.01134222-53.01134222 53.01134222 23.88423111 53.01134223 53.01134222-23.88423111 53.01134222-53.01134223 53.01134222z"
                fill="#004aa1"
                p-id="12745"
              ></path>
            </svg>
            <span>手机</span>
            <!-- <span v-show="lang == '1'">Phone number</span> -->
            <p>{{ CompanyInfor[tabsIndex].cmpPhone }}</p>
          </div>
          <div class="item">
            <svg
              t="1653459450438"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="13852"
              width="28"
              height="28"
            >
              <path
                d="M896 426.666667h-85.333333V341.333333a298.666667 298.666667 0 1 0-597.333334 0v85.333334H128A85.426667 85.426667 0 0 0 42.666667 512v170.666667a85.426667 85.426667 0 0 0 85.333333 85.333333h106.666667a21.333333 21.333333 0 0 0 21.333333-21.333333V341.333333c0-141.16 114.84-256 256-256s256 114.84 256 256v384c0 94.106667-76.56 170.666667-170.666667 170.666667h-3.66a64.106667 64.106667 0 0 0-60.34-42.666667h-42.666666a64 64 0 0 0 0 128h42.666666a64.106667 64.106667 0 0 0 60.34-42.666666H597.333333a213.506667 213.506667 0 0 0 209.086667-170.666667H896a85.426667 85.426667 0 0 0 85.333333-85.333333V512a85.426667 85.426667 0 0 0-85.333333-85.333333z"
                fill="#004aa1"
                p-id="13853"
              ></path>
            </svg>
            <span style="width: 100px">服务范围</span>
            <!-- <span v-show="lang == '1'">Scope of services</span> -->
            <p>{{ CompanyInfor[tabsIndex].cmpService }}</p>
          </div>
          <div
            class="QR_code"
            style="display: flex; justify-content: space-around"
          >
            <div>
              <img
                :src="CompanyInfor[tabsIndex].cmpLinkImg"
                alt="山东微信客服二维码"
                srcset=""
              />
              <p style="font-size: 14px; margin-left: -10px; margin-top: 10px">
                山东公司微信客服
              </p>
            </div>
            <div style="margin-left: 10px">
              <img
                width="100px"
                src="../assets/img/zngzh.jpg"
                alt="公众号二维码"
              />
              <!-- <div><a href="/contact">在线留言</a> </div> -->
              <p style="margin-top: 10px; font-size: 14px">旭瑞智能公众号</p>
            </div>
            <div style="margin-left: 10px">
              <img
                width="100px"
                src="../assets/img/zndyh.jpg"
                alt="抖音号二维码"
              />
              <!-- <div><a href="/contact">在线留言</a> </div> -->
              <p style="margin-top: 10px; font-size: 14px">旭瑞智能抖音号</p>
              <!-- <img src="../assets/gototop/公众号.jpg" /> -->
            </div>
          </div>
        </div>
        <div class="right_map">
          <div class="item" v-if="tabsIndex == 0">
            <baidu-map
              class="map"
              :center="{
                lng: CompanyInfor[tabsIndex].lng,
                lat: CompanyInfor[tabsIndex].lat,
              }"
              :zoom="18"
              :scroll-wheel-zoom="true"
            >
              <bm-marker
                :position="{
                  lng: CompanyInfor[tabsIndex].lng,
                  lat: CompanyInfor[tabsIndex].lat,
                }"
                :dragging="true"
                @click="infoWindowOpen"
              >
                <bm-info-window
                  :show="mapShow"
                  @close="infoWindowClose"
                  @open="infoWindowOpen"
                >
                  <span>{{ CompanyInfor[tabsIndex].cmpName }}</span>
                  <p>地址：{{ CompanyInfor[tabsIndex].cmpAddress }}</p>
                  <p>电话：{{ CompanyInfor[tabsIndex].cmpTelephone }}</p>
                </bm-info-window>
              </bm-marker>
            </baidu-map>
          </div>
          <div class="item" v-else>
            <baidu-map
              class="map"
              :center="{
                lng: CompanyInfor[tabsIndex].lng,
                lat: CompanyInfor[tabsIndex].lat,
              }"
              :zoom="18"
              :scroll-wheel-zoom="true"
            >
              <bm-marker
                :position="{
                  lng: CompanyInfor[tabsIndex].lng,
                  lat: CompanyInfor[tabsIndex].lat,
                }"
                :dragging="true"
                @click="infoWindowOpen"
              >
                <bm-info-window
                  :show="mapShow"
                  @close="infoWindowClose"
                  @open="infoWindowOpen"
                >
                  <span>{{ CompanyInfor[tabsIndex].cmpName }}</span>
                  <p>地址：{{ CompanyInfor[tabsIndex].cmpAddress }}</p>
                  <p>电话：{{ CompanyInfor[tabsIndex].cmpTelephone }}</p>
                </bm-info-window>
              </bm-marker>
            </baidu-map>
          </div>
        </div>
      </div>
      <div class="tabs_content" style="margin-top: 60px; margin-left: -200px">
        <div class="left_text">
          <p>{{ CompanyInfor[1].cmpName }}</p>
          <div class="item">
            <svg
              t="1653458515640"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6930"
              width="28"
              height="28"
            >
              <path
                d="M932.6 878.3H889V311.1c0.1-6.3-3.5-12.1-9.1-15.1L629.7 165c-11.8-6.2-26.1 2.2-26.1 15.1v698.3H573V80.9c0.1-11.9-12.1-20.1-23.8-16L167.5 201.8c-6.9 2.4-11.5 8.9-11.5 16v660.5H92c-9.7 0-17.5 9.2-17.5 20.4v40.7c0 11.2 7.8 20.4 17.5 20.4h840.6c9.7 0 17.5-9.1 17.5-20.4v-40.7c0-11.2-7.8-20.4-17.5-20.4zM693.1 318.2c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.1c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.3c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 105.3c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7V647c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.1c0-14.2 11.8-25.7 26.5-25.7H766c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7V730zM394.4 217.5c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.7c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 105.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7V647c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.7 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7V730zM237.8 318.2c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 103.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 105.3c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7V647c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7v-17.1z m0 100.1c0-14.2 11.8-25.7 26.5-25.7h46.4c14.6 0 26.5 11.4 26.5 25.7v17.1c0 14.2-11.8 25.7-26.5 25.7h-46.4c-14.6 0-26.5-11.4-26.5-25.7V730z"
                p-id="6931"
                fill="#004aa1"
              ></path>
            </svg>
            <span>地址</span>
            <!-- <span v-show="lang == '1'">address</span> -->
            <p>{{ CompanyInfor[1].cmpAddress }}</p>
          </div>
          <div class="item">
            <svg
              t="1653459034663"
              class="icon"
              viewBox="0 0 1025 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="10661"
              width="28"
              height="28"
            >
              <path
                d="M507.918859 650.527512c-49.503789-40.346806-106.623387-94.611243-156.090335-155.822216-34.713235-42.89496-65.404683-87.94306-33.707276-119.633303L95.656089 153.242337C63.221866 193.655661-8.620745 386.103763 299.338585 701.174388c324.458887 332.036833 533.74323 261.005742 569.766359 223.573453L652.205814 708.149578C621.886867 738.400983 582.842793 711.503113 507.918859 650.527512zM947.385483 798.906865l0-0.201601c0 0-169.23738-168.702166-169.343809-168.769707-13.381394-13.347623-34.814547-13.078481-48.127376 0.067541l-61.340939 61.375733 217.469138 217.203066c0 0 61.409504-61.176179 61.342986-61.245767l0.165784-0.132013C961.605005 833.148333 960.162074 811.75202 947.385483 798.906865zM396.298428 297.126091l0-0.168854c14.051691-14.083415 12.74589-35.45005 0-48.196964l0-0.234348c0 0-174.132089-173.597897-174.200654-173.597897-13.452005-13.484753-34.884135-13.148069-48.163193 0l-61.342986 61.441228 222.299375 221.961668C334.888924 358.335017 396.298428 297.225356 396.298428 297.126091z"
                p-id="10662"
                fill="#004aa1"
              ></path>
            </svg>
            <span>电话</span>
            <!-- <span v-show="lang == '1'">Telephone number</span> -->
            <p>{{ CompanyInfor[1].cmpTelephone }}</p>
          </div>
          <div class="item">
            <svg
              t="1653459120545"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="11703"
              width="28"
              height="28"
            >
              <path
                d="M1022.08 716.928V300.48l-217.28 217.344 217.28 199.04M655.36 667.2a188.16 188.16 0 0 1-133.888 55.488c-50.56 0-98.176-19.712-133.952-55.488L270.976 550.592 20.864 779.84v38.4c0 50.24 40.832 91.072 91.008 91.072h819.2c50.176 0 91.008-40.832 91.008-91.008v-39.68l-249.536-228.608-117.12 117.12"
                fill="#004aa1"
                p-id="11704"
              ></path>
              <path
                d="M932.928 128h-819.2C63.616 128 22.848 168.832 22.848 219.008v19.008l398.784 398.912c27.2 27.136 63.36 42.112 101.76 42.112 38.464 0 74.624-14.976 101.76-42.112L1024 238.016v-19.008C1024 168.832 983.04 128 932.928 128M20.864 300.48v417.6L238.72 518.4 20.864 300.48"
                fill="#004aa1"
                p-id="11705"
              ></path>
            </svg>
            <span>邮箱</span>
            <!-- <span v-show="lang == '1'">E-mail</span> -->
            <p>{{ CompanyInfor[1].cmpEmail }}</p>
          </div>
          <div class="item">
            <svg
              t="1653459369775"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="12743"
              width="28"
              height="28"
            >
              <path
                d="M727.54062222 86.74417778c19.22389333 0 34.95253333 15.72864 34.95253333 34.95253333v780.60657778c0 19.22389333-15.72864 34.95253333-34.95253333 34.95253333H296.45937778c-19.22389333 0-34.95253333-15.72864-34.95253333-34.95253333V121.69671111c0-19.22389333 15.72864-34.95253333 34.95253333-34.95253333h431.08124444m0-69.90506667H296.45937778c-57.67168 0-104.8576 47.18592-104.8576 104.8576v780.60657778c0 57.67168 47.18592 104.8576 104.8576 104.8576h431.08124444c57.67168 0 104.8576-47.18592 104.8576-104.8576V121.69671111c0-57.67168-47.18592-104.8576-104.8576-104.8576z"
                fill="#004aa1"
                p-id="12744"
              ></path>
              <path
                d="M765.40586667 789.87264H258.59413333c-36.70016 0-66.99235555 29.70965333-66.99235555 66.99235555v50.68117334c0 36.70016 29.70965333 66.99235555 66.99235555 66.99235556h506.81173334c36.70016 0 66.99235555-29.70965333 66.99235555-66.99235556v-50.68117334c0-37.28270222-30.29219555-66.99235555-66.99235555-66.99235555z m-254.57095112 136.89742222c-29.12711111 0-53.01134222-23.88423111-53.01134222-53.01134222s23.88423111-53.01134222 53.01134222-53.01134222 53.01134222 23.88423111 53.01134223 53.01134222-23.88423111 53.01134222-53.01134223 53.01134222z"
                fill="#004aa1"
                p-id="12745"
              ></path>
            </svg>
            <span>手机</span>
            <!-- <span v-show="lang == '1'">Phone number</span> -->
            <p>{{ CompanyInfor[1].cmpPhone }}</p>
          </div>
          <div class="item">
            <svg
              t="1653459450438"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="13852"
              width="28"
              height="28"
            >
              <path
                d="M896 426.666667h-85.333333V341.333333a298.666667 298.666667 0 1 0-597.333334 0v85.333334H128A85.426667 85.426667 0 0 0 42.666667 512v170.666667a85.426667 85.426667 0 0 0 85.333333 85.333333h106.666667a21.333333 21.333333 0 0 0 21.333333-21.333333V341.333333c0-141.16 114.84-256 256-256s256 114.84 256 256v384c0 94.106667-76.56 170.666667-170.666667 170.666667h-3.66a64.106667 64.106667 0 0 0-60.34-42.666667h-42.666666a64 64 0 0 0 0 128h42.666666a64.106667 64.106667 0 0 0 60.34-42.666666H597.333333a213.506667 213.506667 0 0 0 209.086667-170.666667H896a85.426667 85.426667 0 0 0 85.333333-85.333333V512a85.426667 85.426667 0 0 0-85.333333-85.333333z"
                fill="#004aa1"
                p-id="13853"
              ></path>
            </svg>
            <span style="width: 100px">服务范围</span>
            <!-- <span v-show="lang == '1'">Scope of services</span> -->
            <p>
              负责华中、华南、西北、西南市场商务合作、媒体合作、客户服务等。
            </p>
          </div>
          <div
            class="QR_code"
            style="display: flex; justify-content: space-around"
          >
            <div>
              <img
                src="../assets/img/wxzx.png"
                alt="武汉微信客服二维码"
                srcset=""
              />
              <p style="font-size: 14px; margin-left: -10px; margin-top: 10px">
                武汉公司微信客服
              </p>
            </div>

            <div style="margin-left: 10px">
              <img
                width="100px"
                src="../assets/img/zngzh.jpg"
                alt="公众号二维码"
              />
              <!-- <div><a href="/contact">在线留言</a> </div> -->
              <p style="margin-top: 10px; font-size: 14px">旭瑞智能公众号</p>
            </div>
            <div style="margin-left: 10px">
              <img
                width="100px"
                src="../assets/img/zndyh.jpg"
                alt="抖音号二维码"
              />
              <!-- <div><a href="/contact">在线留言</a> </div> -->
              <p style="margin-top: 10px; font-size: 14px">旭瑞智能抖音号</p>
              <!-- <img src="../assets/gototop/公众号.jpg" /> -->
            </div>
          </div>
        </div>
        <div class="right_map">
          <div class="item" v-if="tabsIndex == 0">
            <baidu-map
              class="map"
              :center="{
                lng: CompanyInfor[1].lng,
                lat: CompanyInfor[1].lat,
              }"
              :zoom="18"
              :scroll-wheel-zoom="true"
            >
              <bm-marker
                :position="{
                  lng: CompanyInfor[1].lng,
                  lat: CompanyInfor[1].lat,
                }"
                :dragging="true"
                @click="infoWindowOpen"
              >
                <bm-info-window
                  :show="mapShow"
                  @close="infoWindowClose"
                  @open="infoWindowOpen"
                >
                  <span>{{ CompanyInfor[1].cmpName }}</span>
                  <p>地址：{{ CompanyInfor[1].cmpAddress }}</p>
                  <p>电话：{{ CompanyInfor[1].cmpTelephone }}</p>
                </bm-info-window>
              </bm-marker>
            </baidu-map>
          </div>
          <div class="item" v-else>
            <baidu-map
              class="map"
              :center="{
                lng: CompanyInfor[1].lng,
                lat: CompanyInfor[1].lat,
              }"
              :zoom="18"
              :scroll-wheel-zoom="true"
            >
              <bm-marker
                :position="{
                  lng: CompanyInfor[1].lng,
                  lat: CompanyInfor[1].lat,
                }"
                :dragging="true"
                @click="infoWindowOpen"
              >
                <bm-info-window
                  :show="mapShow"
                  @close="infoWindowClose"
                  @open="infoWindowOpen"
                >
                  <span>{{ CompanyInfor[1].cmpName }}</span>
                  <p>地址：{{ CompanyInfor[1].cmpAddress }}</p>
                  <p>电话：{{ CompanyInfor[1].cmpTelephone }}</p>
                </bm-info-window>
              </bm-marker>
            </baidu-map>
          </div>
        </div>
      </div>
    </div>
    <div id="Message" style="height: 10px"></div>
    <div class="contact">
      <div class="title">
        <span></span>
        <h2>留言</h2>
        <!-- <span v-show="lang == '1'">Contact US</span> -->
      </div>
      <div class="text">
        <p>
          如果您对我们的产品或服务感兴趣，请填写表单，我们会在第一时间给您答复 !
        </p>
        <!-- <p v-show="lang == '1'">
          If you are interested in our products or services, please fill in the
          form and we will reply to you at the first time
        </p> -->
      </div>
      <div class="biao">
        <el-form ref="form" :model="form" :rules="rules" label-width="auto">
          <div class="name_email">
            <el-form-item label="" prop="fbName">
              <p>姓名：</p>
              <!-- <p v-show="lang == '1'">name：</p> -->
              <el-input
                v-model="form.fbName"
                placeholder="姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="fbPhone">
              <p>电话：</p>
              <!-- <p v-show="lang == '1'">Telephone：</p> -->
              <el-input
                v-model="form.fbPhone"
                placeholder="电话"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item label="" prop="fbMail">
            <p>邮箱：</p>
            <!-- <p v-show="lang == '1'">mailbox：</p> -->
            <el-input
              v-model="form.fbMail"
              placeholder="邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="fbContent">
            <p>留言：</p>
            <!-- <p v-show="lang == '1'">message：</p> -->
            <el-input
              :rows="6"
              type="textarea"
              v-model="form.fbContent"
              placeholder="请输入留言"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="onSubmit">提交</el-button>

            <el-dialog
              title="提交成功"
              :visible.sync="dialogVisible"
              width="30%"
            >
              <span>我们会尽快与您联系！</span>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit"> 确 定</el-button>
              </span>
            </el-dialog>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "联系我们-东营市旭瑞智能科技股份有限公司", // 设置title
    meta: [
      {
        name: "keywords", // 设置关键字
        content:
          "智慧水利，PLC控制柜，闸泵远程控制，智慧城市，智慧城管，智慧水务，城市防汛监测，智慧闸泵，智慧环卫，智慧公厕，智慧园林，智慧执法，智慧渣土，市容秩序提升，智慧工地，智慧道桥，智慧井盖，智慧管网，智慧照明，智慧农业，智能灌溉，水肥一体化，物联网",
      },
      {
        name: "description", // 设置页面描述
        content:
          "旭瑞智能专注于智慧水利、智慧城管、智慧农业及智能化工程等智慧物联网细分领域软硬件产品研发、生产、销售、运营，提供智慧行业整体解决方案。",
      },
    ],
  },
  data() {
    // 自定义邮箱规则
    var checkEmail = (rule, value, callback) => {
      const regEmail =
        /^([\w-\.]+){3,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

      if (regEmail.test(value)) {
        // 合法邮箱
        return callback();
      }
      callback(new Error("请输入正确的邮箱地址"));
    };
    return {
      dialogVisible: false,
      Picurl: "http://101.200.43.114:8710/jeecg-boot/sys/common/static/",
      tabsZH: ["东营市旭瑞智能", "武汉旭瑞创想"],
      tabsEN: ["Dongying XURUI intelligent", "Wuhan xuruichuangxiang"],
      tabsIndex: 0,
      CompanyInfor: [],
      form: {
        fbName: "",
        fbMail: "",
        fbPhone: "",
        fbContent: "",
      },
      rules: {
        fbName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        fbMail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        fbPhone: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur",
        },
        fbContent: [
          { required: true, message: "请输入相关留言", trigger: "blur" },
        ],
      },
      Dongyingcompany: "",
      Wuhancompany: "",
      lang: "",
      img: {},
      mapShow: true,
    };
  },
  watch: {
    $route(to, form) {
      if (to.name == form.name) {
        this.$router.go(0);
      }
    },
  },
  created() {
    this.lang = localStorage.getItem("newv");
    this.getCompanyInfor();

    this.$nextTick(() => {
      this.getlocal();
    });
  },
  updated() {
    if (this.$route.query.name) {
      console.log(this.$route.query.name);
      this.$el.querySelector(this.$route.query.name).scrollIntoView();
    }
  },
  mounted: function () {
    let that = this;
    that.$nextTick(function () {
      window.addEventListener("scroll", that.handleScroll);
    });
    console.log("mounted");
  },
  destroyed() {
    localStorage.getItem("toId", "");
  },
  methods: {
    getlocal() {
      let selectId = localStorage.getItem("toId");
      let toElement = document.getElementById(selectId);
      if (selectId) {
        toElement.scrollIntoView();
      }
    },
    submit() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    infoWindowClose() {
      this.mapShow = false;
    },
    infoWindowOpen() {
      this.mapShow = true;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        console.log("valid :>> ", valid);
        if (valid) {
          console.log(this.form);
          this.dialogVisible = true;
          let data = {
            type: 1,
            fbName: this.form.fbName,
            fbMail: this.form.fbMail,
            fbPhone: this.form.fbPhone,
            fbContent: this.form.fbContent,
            // form:this.form
          };
          this.$API.addMessage(data).then((res) => {
            console.log("res :提交>> ", res);
          });
        }
      });
    },
    // 获取公司列表
    getCompanyInfor() {
      this.$API.getCompanyInfor().then((res) => {
        console.log("res :公司>> ", res);
        this.CompanyInfor = res.data;
        this.CompanyInfor.forEach((e) => {
          let lanLng = e.cmpLnglat.split(",");
          e.lng = lanLng[0];
          e.lat = lanLng[1];
        });
      });
    },
    tabsClick(index) {
      this.tabsIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 34px;
}
h3 {
  font-size: 12px;
  color: #004aa1 !important;
}
.content {
  width: 100%;
  // height: 500px;
  user-select: none;
  .imgbox {
    width: 100%;
    margin-bottom: 50px;
    position: relative;

    div {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      font-size: 28px;
      color: #fff;
    }
  }
  .contact {
    width: 60%;
    padding: 0 20%;
    margin: 100px auto 50px;
    .title {
      position: relative;
      text-align: center;
      span:nth-child(1) {
        display: block;
        width: 80px;
        height: 8px;
        background-color: #004aa1;
        position: absolute;
        left: 50%;
        transform: translate(-40px, -20px);
      }
      span {
        font-size: 34px;
        font-weight: 700;
      }
    }
    .text {
      margin: 20px 0;
      text-align: center;
      p {
        line-height: 30px;
        font-size: 20px;
      }
    }
    .tabs {
      cursor: pointer;
      margin: 50px auto;
      width: 50%;
      display: flex;
      align-items: center;
      border-radius: 25px;
      outline: 1px solid #004aa1;
      .item {
        width: 50%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 25px;
        color: #004aa1;

        span {
          font-size: 20px;
        }
      }
      .active {
        background-color: #004aa1;
        color: #fff;
      }
    }
    .tabs_content {
      display: flex;
      justify-content: space-between;
      width: 80vw;
      .left_text {
        width: 35%;
        p:nth-child(1) {
          font-weight: 600;
          color: #004aa1;
          font-size: 24px;
          text-align: left;
          margin-bottom: 40px;
        }
        .item {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          span {
            font-weight: 600;
            color: #004aa1;
            font-size: 18px;
            margin: 0 10px;
          }
        }
        .QR_code {
          padding: 20px;
          border-top: 1px solid #ddd;
          img {
            width: 90px;
            height: 90px;
          }
        }
      }
      .right_map {
        width: 60%;
        .map {
          width: 100%;
          height: 500px;
          /deep/.anchorBL,
          /deep/.anchorTR,
          /deep/.BMap_zlHolder {
            display: none;
            visibility: hidden;
          }
        }
      }
    }
    .biao {
      width: 80%;
      margin: 30px 10%;
      p {
        text-align: left;
      }
      .name_email {
        display: flex;
        justify-content: space-between;
        .el-form-item {
          width: 47%;
        }
      }
    }
  }
}
</style>
